import React, { useState, useEffect } from "react";
import "./Our_Published_Books.css";
import Common_Title from "../../common/common-title/Common_Title";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";
import Download_Modal from "../../modals/download-modal/Download_Modal";

import { IDS } from "../../../utils/IDS";
import { GetAllPublished } from "../../../features/components/homepage/publishedbook/Slice";
import { useSelector, useDispatch } from "react-redux";

const Our_Published_Books = () => {
  const [showModal, setShowModal] = useState(false);
  const handleDownloadClick = () => {
    setShowModal(true);

    setTimeout(() => {
      setShowModal(false);
    }, 3000);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const journals = [
    {
      img: "/assets/images/home/our_books/book.png",
      category: "Procrastination Journal",
      title: "Do it Now journal",
      author: "Sarth Palktav",
    },
    {
      img: "/assets/images/home/our_books/book.png",
      category: "Procrastination Journal",
      title: "Do it Now journal",
      author: "Sarth Palktav",
    },
    {
      img: "/assets/images/home/our_books/book.png",
      category: "Procrastination Journal",
      title: "Do it Now journal",
      author: "Sarth Palktav",
    },
    {
      img: "/assets/images/home/our_books/book.png",
      category: "Procrastination Journal",
      title: "Do it Now journal",
      author: "Sarth Palktav",
    },
    {
      img: "/assets/images/home/our_books/book.png",
      category: "Procrastination Journal",
      title: "Do it Now journal",
      author: "Sarth Palktav",
    },
  ];

  const dispatch = useDispatch();
  const book = useSelector(
    (state) => state?.homepage?.publishedbook?.all_publishedbook,
  );

  useEffect(() => {
    dispatch(GetAllPublished());
  }, [dispatch]);

  const handleCardClick = (item) => {
    const link = item?.link?.trim();

    if (link) {
      window.open(link, "_blank"); // open in new tab (better UX)
    } else {
      alert("Book not found");
    }
  };

  return (
    <section className="Our_Published_Books">
      <div className="container">
        <Common_Title title="Our Published Books" />

        <div className="journal_section">
          <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true }}
            spaceBetween={0}
            loop
            slidesPerView={4}
            breakpoints={{
              1200: { slidesPerView: 4 },
              992: { slidesPerView: 3 },
              768: { slidesPerView: 2.2 },
              575: { slidesPerView: 2 },
              320: { slidesPerView: 1.2 },
              0: { slidesPerView: 1 },
            }}
          >
            {book?.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  className="journal_card"
                  onClick={() => handleCardClick(item)}
                >
                  <div className="journal_img_div">
                    <img
                      src={IDS?.IMG_URL + item?.image}
                      alt="journal"
                      className="journal_img"
                    />
                  </div>

                  <div className="journal_content">
                    <span className="journal_category">{item?.name}</span>
                    <h4 className="journal_title">{item?.sub_title}</h4>
                    <p className="journal_author">{item?.owner_name}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <Download_Modal show={showModal} handleClose={handleClose} />
    </section>
  );
};

export default Our_Published_Books;
